enum SocketEventType {
  ROBOTIC_MOWER = 'ROBOTIC_MOWER',
  AssetLocationUpdated = 'AssetLocationUpdated',
  AssetConnectivityUpdated = 'AssetConnectivityUpdated',
  AssetCreated = 'AssetCreated',
  AssetDeleted = 'AssetDeleted',
  AssetCSFirmwareUpdated = 'AssetCSFirmwareUpdated',
  AssetFirmwareUpdated = 'AssetFirmwareUpdated',
  AssetPowerUpdated = 'AssetPowerUpdated',
  AssetStatusUpdated = 'AssetStatusUpdated',
  AssetHfsActionsUpdated = 'AssetHfsActionsUpdated',
  AssetHfsOperationUpdated = 'AssetHfsOperationUpdated',
  Reconnection = 'Reconnection',
}

export default SocketEventType;
